import { useQuery } from 'react-query';

import { apiGetListMailTemplate, apiGetMailPlaceholders, apiGetMailLogs, apiGetMailRecipient } from 'api/mailTemplate';
import {
  USE_GET_LIST_MAIL_TEMPLATE,
  USE_GET_MAIL_PLACEHOLDERS,
  USE_GET_MAIL_LOGS,
  USE_GET_MAIL_RECIPIENT,
} from 'constants/MailTemplate';
import { HTTP_OK } from 'constants/StatusCode';

export function useGetListMailTemplate(params, options = {}) {
  const {
    data: response,
    error,
    isLoading,
  } = useQuery(
    [USE_GET_LIST_MAIL_TEMPLATE, params],
    async () => {
      const response = await apiGetListMailTemplate(params);
      if (response.status === HTTP_OK) {
        return response.data;
      }
      return null;
    },
    options,
  );

  return { ...response, error, isLoading };
}

export function useGetMailPlaceholders() {
  const {
    data: response,
    error,
    isLoading,
  } = useQuery(
    [USE_GET_MAIL_PLACEHOLDERS],
    async () => {
      const response = await apiGetMailPlaceholders();
      if (response.status === HTTP_OK) {
        return response.data;
      }
      return null;
    },
    { staleTime: Infinity },
  );

  return { data: response?.data || [], error, isLoading };
}

export function useGetMailLogs(applyId, options = {}) {
  const {
    data: response,
    error,
    isLoading,
  } = useQuery(
    [USE_GET_MAIL_LOGS, applyId],
    async () => {
      const response = await apiGetMailLogs(applyId);
      if (response.status === HTTP_OK) {
        return response.data;
      }
      return null;
    },
    { enabled: !!applyId, ...options },
  );

  return { data: response?.data || [], error, isLoading };
}

// Người nhận thật + chế độ dry run (mail chỉ gửi cho HR) của apply
export function useGetMailRecipient(applyId, options = {}) {
  const {
    data: response,
    error,
    isLoading,
  } = useQuery(
    [USE_GET_MAIL_RECIPIENT, applyId],
    async () => {
      const response = await apiGetMailRecipient(applyId);
      if (response.status === HTTP_OK) {
        return response.data;
      }
      return null;
    },
    { enabled: !!applyId, ...options },
  );

  return { data: response?.data || null, error, isLoading };
}
